import { SITE } from '../config/site';
import { absoluteUrl } from '../config/seo';

export function buildLocalBusinessJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': ['Store', 'LocalBusiness'],
    '@id': `${SITE.url}/#organization`,
    name: SITE.brandName,
    alternateName: SITE.name,
    description: SITE.description,
    url: SITE.url,
    telephone: SITE.phone,
    email: SITE.email,
    image: absoluteUrl(SITE.defaultOgImage),
    logo: absoluteUrl('/icon-512.png'),
    priceRange: '₽',
    currenciesAccepted: 'RUB',
    paymentAccepted: 'Cash, Credit Card, QR',
    address: {
      '@type': 'PostalAddress',
      streetAddress: SITE.streetAddress,
      addressLocality: SITE.addressLocality,
      addressRegion: SITE.addressRegion,
      addressCountry: 'RU',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: SITE.geo.latitude,
      longitude: SITE.geo.longitude,
    },
    openingHoursSpecification: SITE.openingHoursSpec.map(({ days, opens, closes }) => ({
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: days,
      opens,
      closes,
    })),
    sameAs: [SITE.vkUrl, SITE.mapsOrgUrl, SITE.mapsUrl].filter(Boolean),
    areaServed: {
      '@type': 'City',
      name: SITE.city,
    },
    hasMap: SITE.mapsUrl,
  };
}
